import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
  config: { id: 'G-CC5EGRWWF4' },
  pageTrackerScreenview: true, 
}, router)

// Create the Vue app
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')